module.exports = __webpack_public_path__ + "img/edge_hebergements_aire_camping_car.d55539bf.svg";